export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_body-3a18c056d23319c1852401f59bb4fa7f.svg";